module.exports = __webpack_public_path__ + "static/1182-c488d67312bbc929685b57e37da4efc8.svg";